<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">生育服务登记管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          生育服务登记管理系统面向育龄人群与各级卫生健康部门，落实生育登记制度，提供生育登记、再生育审批、出生医学证明关联、孕产期保健衔接等一站式服务。系统通过线上线下协同办理，推动“群众少跑腿、数据多跑路”，实现生育登记“最多跑一次”乃至“一次不用跑”。
        </p>
        <p class="content-paragraph">
          系统构建群众端、村（居）端、乡镇端、县级管理端与省级监管端五级应用体系，支持材料在线提交、电子证照调用、分级审核审批、电子签章出件、跨省通办；同步汇聚生育登记数据，开展出生人口监测、生育政策落实情况分析与数据共享上报，为完善生育支持政策体系、促进人口长期均衡发展提供数据支撑。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">在线登记服务</h3>
            <ul class="capability-list"><li>一孩二孩三孩登记</li><li>材料在线提交</li><li>电子证照调用</li><li>办事指南</li><li>进度实时查询</li><li>电子结果送达</li><li>移动端与自助端</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">审核审批管理</h3>
            <ul class="capability-list"><li>村居受理</li><li>乡镇审核</li><li>县级审批</li><li>承诺制办理</li><li>跨省通办</li><li>电子签章出件</li><li>补正与退回</li><li>档案管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">统计监测分析</h3>
            <ul class="capability-list"><li>生育登记统计</li><li>出生人口监测</li><li>政策落实分析</li><li>生育意愿调查</li><li>数据共享上报</li><li>专题报表</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sy-mobile.svg"
              alt="海南华德科技有限公司 生育服务登记管理系统 - 群众端 · 生育登记在线办理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>群众端 · 生育登记在线办理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sy-approval.svg"
              alt="海南华德科技有限公司 生育服务登记管理系统 - 审核工作台 · 分级审批与出件"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>审核工作台 · 分级审批与出件
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sy-manage.svg"
              alt="海南华德科技有限公司 生育服务登记管理系统 - 县级管理端 · 办件监管与档案"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>县级管理端 · 办件监管与档案
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sy-monitor.svg"
              alt="海南华德科技有限公司 生育服务登记管理系统 - 监测大屏 · 出生人口与政策落实分析"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>监测大屏 · 出生人口与政策落实分析
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs2.vue